routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.shoppingExperience', {
      url: __env.routes.shoppingExperience,
      template: `<shopping-experience sh-ctrl="shCtrl" ></shopping-experience>`
    });
}

export default routesConfig;




// WEBPACK FOOTER //
// ./www/components/shopping-experience/shopping-experience.config.js